import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Projects from "../components/Projects";
import InvestmentGuide from "../components/InvestmentGuide";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => (
  <div className="bg-ivory min-h-screen" data-testid="home-page">
    <Navbar />
    <main>
      <Hero />
      <About />
      <Projects />
      <InvestmentGuide />
      <Contact />
    </main>
    <Footer />
  </div>
);

export default Home;
